import { LanguageEnum } from "../types";

export const translateText = (text: string, language: LanguageEnum): string => {
    // Direct match case
    if (translations[text]) {
        return language === "japanese"
            ? translations[text].japanese || translations[text].english || text
            : translations[text].english || translations[text].japanese || text;
    }

    // Suffix mapping
    const suffixes = {
        "-english": "english",
        "-japanese": "japanese",
        "-英語": "english",
        "-日本語": "japanese"
    };

    for (const suffix in suffixes) {
        if (text.endsWith(suffix)) {
            const baseText = text.slice(0, -suffix.length); // Remove suffix
            if (translations[baseText]) {
                const foundLanguage = suffixes[suffix as keyof typeof suffixes]; // The language in the suffix
                const translatedBase =
                    language === "japanese"
                        ? translations[baseText].japanese || translations[baseText].english || baseText
                        : translations[baseText].english || translations[baseText].japanese || baseText;
                const translatedSuffix =
                    language === "japanese"
                        ? (foundLanguage === "english" ? "英語" : "日本語")
                        : (foundLanguage === "english" ? "english" : "japanese");
                return `${translatedBase}-${translatedSuffix}`;
            }
        }
    }

    // If no match found, return original text
    return text;
};

const translations: { [key: string]: {english: string, japanese: string} } = {
    "firstName": {english: "First Name", japanese: "名"},
    "lastName": {english: "Last Name", japanese: "姓"},
    "firstNamePhonetic": {english: "First Name Phonetic", japanese: "名（ふりがな）"},
    "lastNamePhonetic": {english: "Last Name Phonetic", japanese: "姓（ふりがな）"},
    "companyName": {english: "Company Name", japanese: "会社名"},
    "branch": {english: "Branch", japanese: "部署"},
    "title": {english: "Title", japanese: "役職"},
    "email": {english: "Email", japanese: "メール"},
    "phone": {english: "Phone", japanese: "電話"},
    "mobile": {english: "Mobile", japanese: "携帯"},
    "fax": {english: "Fax", japanese: "FAX"},
    "address": {english: "Address", japanese: "住所"},
    "address2": {english: "Address2", japanese: "住所2"},
    "address3": {english: "Address3", japanese: "住所3"},
    "address4": {english: "Address4", japanese: "住所4"},
    "address5": {english: "Address5", japanese: "住所5"},
    "headPhone": {english: "Head Phone", japanese: "本社電話"},
    "headFax": {english: "Head Fax", japanese: "本社FAX"},
    "headAddress": {english: "Head Address", japanese: "本社住所"},
    "url": {english: "URL", japanese: "URL"},
    "mockCard": {english: "Mock Card", japanese: "モックカード"},
};

